import { useState, useEffect } from "react";
import { Segment, Button, Container, Icon, Transition } from "semantic-ui-react";
import { initAnalytics } from "../utils/analytics";

export default function CookieConsent() {
    const [consent, setConsent] = useState(localStorage.getItem("cookie_consent"));
    const [visible, setVisible] = useState(false);

    // Inicializuj GA len po súhlase
    useEffect(() => {
        if (consent === "accepted") {
            initAnalytics();
        } else if (!consent) {
            const timer = setTimeout(() => setVisible(true), 400);
            return () => clearTimeout(timer);
        }
    }, [consent]);

    const handleAccept = () => {
        localStorage.setItem("cookie_consent", "accepted");
        setVisible(false);
        setTimeout(() => setConsent("accepted"), 500);
    };

    const handleDecline = () => {
        localStorage.setItem("cookie_consent", "declined");
        setVisible(false);
        setTimeout(() => setConsent("declined"), 500);
    };

    if (consent) return null;

    return (
        <Transition visible={visible} animation="fade down" duration={700}>
            <Segment
                inverted
                color="white"
                vertical
                style={{
                    position: "fixed",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    width: "100%",
                    zIndex: 2000,
                    padding: "1.2em 0",
                    borderRadius: 0,
                    boxShadow: "0 -2px 12px rgba(0,0,0,0.3)",
                }}
            >
                <Container text textAlign="center">
                    <p style={{ margin: "0.5em 0" }}>
                        Používame Cookies na analytické účely. {" "}
                        <a href="/cookies" style={{ textDecoration: "underline", color: "#eaae00" }}>
                            Viac informácií
                        </a>
                        .
                    </p>
                    <Button
                        color="yellow"
                        onClick={handleAccept}
                        size="small"
                        style={{ marginRight: "0.5em" }}
                    >
                        Súhlasím
                    </Button>
                    <Button basic color="yellow" onClick={handleDecline} size="small">
                        Nesúhlasím
                    </Button>
                </Container>
            </Segment>
        </Transition>
    );
}
